module.exports = __webpack_public_path__ + "public/img/gongxu_3.75b005d2.png";